import * as yup from 'yup';

export const professionalProfileUpdateSchema = yup.object({
    name: yup.string().required('Full Name is required'), // Required field
    ss_number: yup.string().required('SSN is required'), // Required field
    // address: yup.string(), // Optional field
    about: yup.string().required('About Yourself is required'), // Required field
});